import { useState, useEffect, createContext } from 'react';
import { Webfontloader } from '../../lib';

const FontContext = createContext(null);

const FontLoader = ({ config = {}, children }) => {
  return (
    <Webfontloader>
      {({ load }) => (
        <FontProvider config={config} load={load}>
          {children}
        </FontProvider>
      )}
    </Webfontloader>
  )
}

const FontProvider = ({
  config = {},
  load,
  children
}) => {

  const [status, setStatus] = useState();

  const handleLoading = () => setStatus("loading");

  const handleActive = () => setStatus("active");

  const handleInactive = () => setStatus("inactive");

  useEffect(() => {
    const loadFont = async () => {
      await load({
        ...config,
        loading: handleLoading,
        active: handleActive,
        inactive: handleInactive
      });
    }
    if (load && config) {
      loadFont();
    }
  }, [config, load]);

  return (
    <FontContext.Provider value={{ font: status }}>
      {children}
    </FontContext.Provider>
  )
}


if (process.env.NODE_ENV !== 'production') {
  FontProvider.displayName = "FontProvider";
  FontLoader.displayName = "FontProvider";
}

export default FontLoader;

